// TODO: type needs to be corrected
/* eslint-disable @typescript-eslint/no-unsafe-return */

import type { CognitoUser } from 'amazon-cognito-identity-js';

import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
import { Auth } from 'aws-amplify';

import { getAuthConfig } from '@/shared/config';

import { AMPLIFY_PROVIDER_STORAGE_KEY } from '../constants/amplify';
import { SSO_PROVIDERS } from '../constants/ssoProviders';

export const AUTH_API = {
  changePassword: async (oldPassword: string, newPassword: string) => {
    try {
      // TODO: type needs to be corrected
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const user = await AUTH_API.checkUser();
      return await Auth.changePassword(user, oldPassword, newPassword);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  checkUser: async (): Promise<CognitoUser> => {
    try {
      return await Auth.currentAuthenticatedUser();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  confirmSignUp: async (username: string, code: string) => {
    try {
      return await Auth.confirmSignUp(username, code);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  forgotPassword: async (username: string) => {
    try {
      return await Auth.forgotPassword(username);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  forgotPasswordSubmit: async (username: string, code: string, newPassword: string) => {
    try {
      return await Auth.forgotPasswordSubmit(username, code, newPassword);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  resendConfirmationCode: async (username: string) => {
    try {
      return await Auth.resendSignUp(username);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  signIn: async (username: string, password: string) => {
    try {
      return Auth.signIn(username, password);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  signOut: async () => {
    try {
      localStorage.removeItem(AMPLIFY_PROVIDER_STORAGE_KEY);
      return await Auth.signOut();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  signUp: async (username: string, password: string, email: string) => {
    try {
      const { user } = await Auth.signUp({
        attributes: {
          email,
        },
        autoSignIn: {
          // optional - enables auto sign in after user is confirmed
          enabled: true,
        },
        password,
        username: email,
      });
      return user;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  socialSignIn: async (socialNetwork: CognitoHostedUIIdentityProvider | SSO_PROVIDERS) => {
    try {
      if (socialNetwork === SSO_PROVIDERS.ENTRAID) {
        localStorage.setItem(AMPLIFY_PROVIDER_STORAGE_KEY, socialNetwork);
        const config = getAuthConfig(socialNetwork);
        Auth.configure(config);
      }

      return await Auth.federatedSignIn({
        provider: socialNetwork as CognitoHostedUIIdentityProvider,
      });
    } catch (error) {
      return Promise.reject(error);
    }
  },
  deleteAccount: async () => {
    try {
      return await Auth.deleteUser();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  getAccessToken: async () => {
    try {
      const session = await Auth.currentSession();
      return session.getAccessToken().getJwtToken();
    } catch (e) {
      return Promise.reject(e);
    }
  },
  getTokenId: async () => {
    try {
      const session = await Auth.currentSession();
      return session.getIdToken().getJwtToken();
    } catch (e) {
      return Promise.reject(e);
    }
  },
  getUserInfo: async () => {
    try {
      return await Auth.currentUserInfo();
    } catch (e) {
      return Promise.reject(e);
    }
  },
};
